import { render, staticRenderFns } from "./DigitalServices.vue?vue&type=template&id=7a47783c&scoped=true&"
import script from "./DigitalServices.vue?vue&type=script&lang=js&"
export * from "./DigitalServices.vue?vue&type=script&lang=js&"
import style0 from "./DigitalServices.vue?vue&type=style&index=0&id=7a47783c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a47783c",
  null
  
)

export default component.exports